module.exports = __webpack_public_path__ + "static/media/score_heatmap_4.820e0a4b.png";